/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Keys_DescInputs */

const en_settings_keys_desc = /** @type {(inputs: Settings_Keys_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A key works across **all your workspaces** — create it once, use it in the CLI or MCP. The key is shown only once, when created.`)
};

const id_settings_keys_desc = /** @type {(inputs: Settings_Keys_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key berlaku untuk **semua workspace** kamu — buat sekali, pakai di CLI atau MCP. Key hanya ditampilkan sekali saat dibuat.`)
};

/**
* | output |
* | --- |
* | "A key works across **all your workspaces** — create it once, use it in the CLI or MCP. The key is shown only once, when created." |
*
* @param {Settings_Keys_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_keys_desc = /** @type {((inputs?: Settings_Keys_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Keys_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_keys_desc(inputs)
	return en_settings_keys_desc(inputs)
});